<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "customer",
      key: "id",
      url: {},
      items: [
        {
          label: "合同名称",
          name: "contractName",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "合同金额",
          name: "contractMoney",
          value: "0",
          type: "number",
          width: "400px",
          min: 0,
          formatter: (value) => `¥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          parser: (value) => value.replace(/\¥\s?|(,*)/g, ""),
        },
        {
          label: "关联物资",
          name: "consumable",
          value: "",
          type: "multiple",
          width: "400px",
          dropList: [],
          onChange: this.onCouponAlis,
        },
        {
          label: "供应商",
          name: "supplierId",
          value: "",
          type: "select",
          width: "400px",
          dropList: [],
        },
        {
          label: "付款比例",
          name: "payProportion",
          value: "100",
          type: "number",
          width: "400px",
          min: 0,
          max: 100,
          formatter: (value) => `${value}%`,
          parser: (value) => value.replace("%", ""),
        },
        {
          label: "付款方式",
          name: "payMethod",
          value: "",
          type: "select",
          width: "400px",
          value: 1,
          dropList: [
            {
              value: 1,
              name: "对公协议发货",
            },
            {
              value: 2,
              name: "对公预付款 ",
            },
            {
              value: 3,
              name: "对私预付款",
            },
          ],
        },
        {
          label: "付款状态",
          name: "payState",
          value: "",
          type: "select",
          width: "400px",
          value: 1,
          dropList: [
            {
              value: 1,
              name: "已付款",
            },
            {
              value: 2,
              name: "未付款",
            },
          ],
        },
        {
          label: "开票状态",
          name: "invoiceState",
          value: "",
          type: "select",
          width: "400px",
          value: 1,
          dropList: [
            {
              value: 1,
              name: "已开票",
            },
            {
              value: 2,
              name: "未开票",
            },
          ],
        },
        {
          label: "采购合同",
          name: "fileUrl",
          value: "",
          type: "documents",
          desc: "",
          handleRemove: this.handleRemove,
        },
      ],
      forms: {
        id: "",
      },
    };
  },
  props: {
    item: "",
    action: "",
    procurementId: "",
  },
  created() {
    this.getSupplierList();
    if (this.action == "edit") {
      this.getprocurementWork(this.procurementId);
    } else {
      this.getprocurementWork(this.item);
    }
  },
  methods: {
    onCouponAlis(val) {
      let ass = val.join(",");
      this.forms.consumableIds = ass;
    },
    initData() {
      // 加载详情数据
      let id = this.item;
      this.forms.id = id;
      $utils.api.load(`/admin/system/procurementContract/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
          if (this.action == "edit") {
            let ids = res.data.consumableIds;
            let consumableIds = ids.split(',').map(item => item.trim());
            this.forms.consumable = consumableIds.map(Number);
          }
        }
      });
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      if (this.action == "add") {
        q.procurementId = this.item;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(
              `/admin/system/procurementContract`,
              q,
              this.action == "edit" ? "PUT" : "POST"
            )
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                this.$Modal.remove();
                setTimeout(function () {
                  $utils.url.go(0);
                }, 1000);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    async getSupplierList() {
      let res = await $utils.api.load(
        "/admin/system/procurementSupplier/list",
        {},
        "get"
      );
      if (res.code == 200) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.supplierName;
          // xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "supplierId") {
            // this.items[index]['dropList'] = dropList
            this.items[index]["dropList"] = (this.items[index]["dropList"] || []).concat(
              dropList
            );
          }
        }
      }
    },
    async getprocurementWork(id) {
      let res = await $utils.api.load(
        `/admin/system/procurementWork/consumableByProcurementId/${id}`,
        {},
        "get"
      );
      if (res.code == 200) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.inventoryId;
          xx.name = element.model + "/" + element.name;
          // xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "consumable") {
            // this.items[index]['dropList'] = dropList
            this.items[index]["dropList"] = (this.items[index]["dropList"] || []).concat(
              dropList
            );
          }
        }
      }
    },
  },
};
</script>
